module.exports = __webpack_public_path__ + "img/pr-11.eb70d4a9.png";